import { render, staticRenderFns } from "./bibangReviewRegModal.vue?vue&type=template&id=7bf2cae3&scoped=true"
import script from "./bibangReviewRegModal.vue?vue&type=script&lang=js"
export * from "./bibangReviewRegModal.vue?vue&type=script&lang=js"
import style0 from "./bibangReviewRegModal.vue?vue&type=style&index=0&id=7bf2cae3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf2cae3",
  null
  
)

export default component.exports